import React from "react";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

export const ConfirmationModal = ({ confirmModalOpen, setConfirmModalOpen, title, message, cancelButtonText, confirmButtonText, confirmHandler }) => {

  const toggle = () => {
    setConfirmModalOpen(!confirmModalOpen);
  };

  const handleConfirm = () => {
    confirmHandler();
    setConfirmModalOpen(false);
  };

  return (
    <>
      <Modal isOpen={confirmModalOpen} toggle={toggle} size={"md"} centered>
        <ModalHeader>
          <h3>{title}</h3>
        </ModalHeader>
        <ModalBody>
          <Row className="w-100 mx-0">
            <Col md={12} className="d-flex justify-content-center">
              <h5 className="text-center">
                {message}
              </h5>
            </Col>
          </Row>
          <div className="modal-btns d-flex align-items-center justify-content-center mt-3">
            <button
              className="btn-small btn btn-transparent mr-1 "
              onClick={toggle}
            >
              {cancelButtonText || 'Cancel'}
            </button>

            <button
              className="btn-small m-0 btn"
              onClick={handleConfirm}
            >
              {confirmButtonText || 'Confirm'}
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};
